/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import TreatmentHistoryChangedJournalEvent from "parog-web/models/treatment-history-changed-journal-event";

export default class TreatmentHistoryEditionFormComponent extends CrudJournalEventBaseComponent {
  static forcDisplayName = "Historique des traitements";
  static fullComponentId = "treatment-history/edition-form";

  static journalEventClass = TreatmentHistoryChangedJournalEvent;

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get model() {
    if (this.isNewMode) {
      const attrs = {
        surgerySurgeries: [],
        chemotherapies: [],
        oncologies: [],
        radiotherapies: [],
        immunotherapies: [],
        targetedTherapies: [],
        hormonotherapies: [],
        otherFollowUpEvents: [],
        protocols: []
      };

      return this.store.createRecord(
        "treatment-history-changed-journal-event",
        {
          occurredAt: new Date(),
          ...attrs
        }
      );
    }

    return this.retrievedJournalEvent as TreatmentHistoryChangedJournalEvent;
  }

  async save(): Promise<TreatmentHistoryChangedJournalEvent> {
    const je = await super.save();
    await je.clearAndFetchAssociatedTaskAndConsultation();
    return je;
  }
}
